import React from 'react';
import { Reveal } from './Reveal';
const bonuses = [{
  title: 'Hispanic Culture Calendar',
  description: 'A year of celebrations and traditions with mini-lessons',
  price: '$19',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/df12d4c4-c0a2-4ee4-9ad5-4bf0f1f1ac08.jpg'
}, {
  title: 'No-Prep Classroom Games',
  description: '30 zero-prep games to teach and review',
  price: '$19',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/4e8b2ea3-d851-494b-8999-74e57934b4a1.jpg'
}, {
  title: 'Pronunciation Guide',
  description: 'Sounds and accents made simple',
  price: '$17',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/4577df5b-e46d-4297-ad0f-ec12d7e8a606.jpg'
}, {
  title: 'Teacher’s Toolkit & Certificates',
  description: 'Assessments, rubrics and editable certificates',
  price: '$24',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/01d20c51-989c-45a7-9ca8-24397ee1b653.jpg'
}, {
  title: '1,000 Essential Words',
  description: 'A thematic vocabulary vault with flashcards',
  price: '$21',
  image: 'https://cdn.magicpatterns.com/patterns/generated-images/17f31498-d4f2-45f7-89cc-577dfbdcd0cb.jpg'
}];
export function BonusesSection() {
  return <section className="bg-brand-dark px-4 py-20 md:py-28" data-id="element-17" data-mp="7ma3s8qilvor">
      <Reveal className="mx-auto max-w-3xl" data-id="element-18" data-mp="ckboey3la32c">
        <div className="mb-12 text-center" data-id="element-19" data-mp="cjjr9iucfx9y">
          <div className="inline-flex rounded-full bg-brand-teal/15 px-4 py-2 text-[10px] font-extrabold tracking-[0.14em] text-brand-teal" data-id="element-20" data-mp="gl58thhtozqh">
            INCLUDED FREE TODAY
          </div>
          <h2 className="mt-4 text-3xl font-black text-brand-blue md:text-4xl" data-id="element-21" data-mp="qb6ww9a6ei5e">
            🎁 5 Exclusive Bonuses
          </h2>
          <p className="mt-4 text-brand-gray" data-id="element-22" data-mp="vbck9d9exiho">
            Included free when you get the pack today — valued at{' '}
            <span className="font-bold text-brand-purple line-through" data-id="element-23" data-mp="109w7ri3nn2c5">
              $100 USD
            </span>
            .
          </p>
        </div>
        <div className="space-y-3" data-id="element-24" data-mp="5me7q6i4aqyy">
          {bonuses.map((bonus, index) => <article key={bonus.title} className="flex items-center gap-4 rounded-2xl border border-brand-blue/[0.06] bg-brand-alt p-4 shadow-sm sm:gap-5" data-id="element-25" data-mp="5kb9iz6t9rj5" data-mpi={index}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-brand-blue font-serif font-bold text-white" data-id="element-26" data-mp="fih5z19um5gm">
                {index + 1}
              </span>
              <img src={bonus.image} alt={`Cover of ${bonus.title}`} className="h-20 w-14 shrink-0 rounded-md border border-brand-dark object-cover shadow-sm sm:h-24 sm:w-[4.25rem]" data-id="element-27" data-mp="oeqa2t8rts93" />
              <div className="min-w-0 flex-1" data-id="element-28" data-mp="350hmomourn4i">
                <h3 className="font-bold leading-snug text-brand-blue" data-id="element-29" data-mp="353dju8svm7rw">
                  {bonus.title}
                </h3>
                <p className="mt-1 text-xs" data-id="element-30" data-mp="1fkdwxzy57120">
                  <span className="text-brand-gray" data-id="element-31" data-mp="1flgq6eixtfl3">{bonus.description}</span>
                  <span className="ml-2 font-semibold text-brand-purple line-through" data-id="element-32" data-mp="1kji6irozb0sv">
                    normally {bonus.price}
                  </span>
                  <span className="ml-2 font-extrabold text-brand-teal" data-id="element-33" data-mp="15shxakger2vo">FREE</span>
                </p>
              </div>
            </article>)}
        </div>
      </Reveal>
    </section>;
}